/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type AgendaItemSignalState =
	(typeof AgendaItemSignalState)[keyof typeof AgendaItemSignalState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgendaItemSignalState = {
	open: 'open',
	discussed: 'discussed',
	assessed: 'assessed',
	planned: 'planned',
	follow_up: 'follow_up',
} as const;
